module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Stadt_Wil_SG-1f69700f94fc2a2d3b00d680e782796a.svg";